import { Component, OnDestroy, OnInit, AfterViewInit, HostListener } from '@angular/core';
import { NbDialogService, NbMediaBreakpointsService, NbMenuItem, NbMenuService, NbSearchService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
declare var $;
import { global } from '../../../../global';
import { GithubService } from '../../../services/github.service';
import { MarkdownEditorService } from '../../../pages/markdown-editor/markdown-editor.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  markdownInstance: MarkdownEditorService;

  currentTheme = 'dark';

  userMenu: NbMenuItem[] = [ { title: 'Log out', link: '/' } ];

  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private themeService: NbThemeService,
              private router: Router,
              private dialog: NbDialogService,
              public githubService: GithubService,
              public authService: AuthService,
              private searchService: NbSearchService,
              private breakpointService: NbMediaBreakpointsService) {
                this.markdownInstance = MarkdownEditorService.getInstance(githubService);
                this.menuService.onItemClick().subscribe((data) => {
                  if (data.item.title === 'Log out') {
                    this.authService.logout();
                  }
                });
  }

  openTemplate(template) {
    this.dialog.open(template);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (this.isItSmallViewport()) {
      this.sidebarService.collapse('menu-sidebar');
    } else {
      this.sidebarService.expand('menu-sidebar');
    }
  }

  isItSmallViewport() {
    return this.breakpointService.getByWidth(window.innerWidth).width <= this.breakpointService.getBreakpointsMap().md;
  }

  async ngOnInit() {
    this.currentTheme = 'dark';
    this.changeTheme(this.currentTheme);


    this.searchService.onSearchSubmit()
      .subscribe((data: any) => {
        const value = data.term;
        this.markdownInstance.searchFilesInRepo(value);
      })


    this.user = await this.authService.getUser();
    this.userMenu.splice(0, 0, { title: 'Profile', url: this.user.html_url });

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    return false;
  }

  saveConfig() {
    console.log('saving config', this.markdownInstance.config);
    this.markdownInstance.saveConfig();
  }

  ngAfterViewInit() {
    this.onResize(null);
  }
}
